'use strict';exports.__esModule = true;exports.shareFB = exports.initFBSDK = undefined;var _scriptLoaders = require('../helpers/scriptLoaders');
var _constants = require('../constants');

var initFBSDK = exports.initFBSDK = function initFBSDK(locale) {return (0, _scriptLoaders.facebookSDKLoader)(locale).
  then(function () {return global.FB && global.FB.init({
      appId: _constants.socialNetworks.FACEBOOK_APP_ID,
      status: true,
      xfbml: true,
      version: 'v2.7' });});};


var shareFB = exports.shareFB = function shareFB(shareUrl, callback) {return global.FB && global.FB.ui({
    method: 'share',
    href: shareUrl,
    app_id: _constants.socialNetworks.FACEBOOK_APP_ID },
  callback);};


//////////////////
// WEBPACK FOOTER
// ./src/utils/facebookSDK.js
// module id = 1287
// module chunks = 0